var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Info",
    transform: "translate(-237 -306)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8627",
    "data-name": "Rectangle 8627",
    width: 16,
    height: 16,
    transform: "translate(237 306)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24469",
    "data-name": "Group 24469",
    transform: "translate(238.895 307.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    transform: "translate(0.105 0.105)",
    fill: "none",
    stroke: "#7e8299",
    strokeWidth: 1.4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16982",
    "data-name": "Path 16982",
    d: "M2.786-7.934H1.106v5.14h1.68Zm0,7.178a.852.852,0,0,0-.84-.84.842.842,0,0,0-.84.84.871.871,0,0,0,.84.84A.861.861,0,0,0,2.786-.756Z",
    transform: "translate(4.159 10.031)",
    fill: "#7e8299"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo2);
export default __webpack_public_path__ + "static/media/info-2.3b1df1510bc0f6fca0c27b7496401cba.svg";
export { ForwardRef as ReactComponent };